import { FaArrowLeft } from "react-icons/fa";
import { Link } from "react-router-dom";
import { TranslateString } from "Utils/Common";

function TendersHeading(props: any) {
    return (
        <div className="ant-card ant-card-bordered cu-mb-10 cu-px-10 w-100 text-left cu-tab-text">
            <Link to={`/housingcompany`}>
                <h4 className="cu-m-0 cu-p-0">
                    <button className="ant-btn cu-border-0 back-btn text-primary"><FaArrowLeft style={{ fontWeight: 900, fontSize: '18px' }} /></button>
                    &nbsp;
                    <button className="ant-btn cu-border-0 h4 pl-0 align-middle mb-0">{TranslateString('tendering_list_for_moderator')}</button>
                </h4>
            </Link>
        </div>
    );
}
export default TendersHeading;